import React from 'react'

import EditDistrictForm from '../../modules/District/components/EditDistrictForm'
export default function EditDistrictPage() {
  return <EditDistrictForm />
}
